import { render, staticRenderFns } from "./StoreAutoAcceptManage.vue?vue&type=template&id=2b4da0f5&scoped=true&"
import script from "./StoreAutoAcceptManage.vue?vue&type=script&lang=js&"
export * from "./StoreAutoAcceptManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4da0f5",
  null
  
)

export default component.exports